<template>
  <div class="d-flex flex-column mt-6 col-md-6">
    <div class="">
      <div class="d-flex align-items-center text-center my-5">
        <i-globe class="mx-2" width="2.5em" height="2.5em"></i-globe>

        <div class="font-weight-bold">
          {{ t("Who can see my health information?") }}
        </div>
      </div>
      <div>
        <select
          class="form-control col-md-6 offset-md-3"
          v-model="privacy_value"
        >
          <option value="1">{{ t("Only me") }}</option>
          <option value="2">{{ t("All Doctors") }}</option>
          <option value="3">{{ t("Specific Doctor(s)") }}</option>
        </select>
      </div>
      <div class="mt-4" v-show="privacy_value === '3'">
        <multiselect
          v-model="selectedDoctor"
          :multiple="true"
          :options="options"
          :custom-label="customLabel"
          track-by="id"
          :placeholder="this.t('Choose Doctors')"
          class="col-md-6 offset-md-3"
        >
        </multiselect>
      </div>
      <button @click="addList" class="my-2 col-2 offset-5 btn-click">
        {{ t("Submit") }}
      </button>
    </div>
  </div>
</template>

<script>
import IGlobe from "../../components/Icons/ILock";
import { onlineURL } from "../../repositories/DataSource";
import Multiselect from "vue-multiselect";
import axios from "axios";
export default {
  name: "AboutUs",
  components: {
    IGlobe,
    Multiselect,
  },
  inject: ["patientRepo", "localStorageRepo"],
  mounted() {
    this.fetchDoctors();
    this.fetchAccesses();
  },
  data() {
    return {
      privacy_value: -1,
      options: [],
      selectedDoctor: [],
    };
  },
  methods: {
    async fetchAccesses() {
      await axios
        .get(`${onlineURL}/patient/get-patient-access`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${
              JSON.parse(localStorage.getItem("user")).token
            }`,
          },
        })
        .then((response) => {
          console.log(response.data.message);
          if (response.data.message == "201") {
            this.privacy_value = "2";
          } else if (response.data.message == "404") this.privacy_value = "1";
          else {
            this.selectedDoctor = response.data.data;
            this.privacy_value = "3";
          }
        })
        .catch((error) => {
          // Handle any errors that occur during the request
          console.error("Error:", error);
        });
    },
    async fetchDoctors() {
      await axios
        .get(`${onlineURL}/practitioners`)
        .then((response) => {
          if (response.data.data != "All" || response.data.data != null)
            this.options = response.data.data;
        })
        .catch((error) => {
          // Handle any errors that occur during the request
          console.error("Error:", error);
        });
    },
    customLabel(option) {
      let full_name = option.first_name + " " + option.last_name;
      return full_name;
    },

    addList() {
      let practitioners = [];
      if (this.selectedDoctor != null)
        practitioners = this.selectedDoctor.flatMap((x) => x.id);
      this.$swal
        .fire({
          title: this.t("Confirm"),
          text: this.t(
            "Do you agree to authorize selected parties to access your health data when needed?"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.t("Yes , I agree"),
          cancelButtonText: this.t("No"),
        })
        .then((result) => {
          if (result.value) {
            axios
              .post(
                `${onlineURL}/patient/edit-privacy`,
                {
                  privacy_value: this.privacy_value,
                  doctors: practitioners,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${
                      JSON.parse(localStorage.getItem("user")).token
                    }`,
                  },
                }
              )
              .then((response) => {
                this.$swal.fire({
                  title: this.t("Thank you"),
                  icon: "success",
                });
              })
              .catch((error) => {
                // Handle any errors that occur during the request
                console.error("Error:", error);
              });
          }
        });
      //
    },
  },
};
</script>
<style>
.col-md-6 {
  padding-left: 0 !important;
}
.multiselect__tag {
  background: linear-gradient(90deg, #e21851, #3266f5) !important;
}
button.btn-click {
  border-radius: 15px;
  background: linear-gradient(90deg, #e21851, #3266f5) !important;
  color: white;
  border: 0;
  padding: 5px;
}
.d-flex.flex-column.mt-6.col-md-6.flex-grow-1.bg-white.shadow.overflow-auto.h-100.border-top-radius:dir(
    rtl
  ) {
  margin-right: 25%;
}
.d-flex.flex-column.mt-6.col-md-6.flex-grow-1.bg-white.shadow.overflow-auto.h-100.border-top-radius:dir(
    ltr
  ) {
  margin-left: 25%;
}
.form-control:dir(rtl) {
  margin-right: 22%;
}
.multiselect:dir(rtl) {
  margin-right: 20%;
}
select::after {
  position: absolute;
  width: 40px;
  height: 38px;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  text-align: center;
  transition: transform 0.2s ease;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
